/*
 * @Author: LiuMeiYu
 * @Date: 2022-07-15 14:16:07
 * @LastEditors: LiuMeiYu
 * @LastEditTime: 2023-03-15 10:28:05
 * @FilePath: \nivara\src\utils\utils.js
 * @Description: *
 * *
 * Copyright (c) 2022 by yihua, All Rights Reserved.
 */
import {
    ElMessage
} from "element-plus";
export function formatDate(datetime) {
    var newDate = new Date(datetime * 1000);
    // 获取年月日时分秒值  slice(-2)过滤掉大于10日期前面的0
    var year = newDate.getFullYear(),
        month = ("0" + (newDate.getMonth() + 1)).slice(-2),
        date = ("0" + newDate.getDate()).slice(-2),
        hour = ("0" + newDate.getHours()).slice(-2),
        minute = ("0" + newDate.getMinutes()).slice(-2),
        second = ("0" + newDate.getSeconds()).slice(-2);
    // 拼接
    var result = year + "-" + month + "-" + date + " " + hour + ":" + minute + ":" + second;
    // 返回
    return result;
}
export function timeAgo(time) {
    var data = new Date(time);
    var dateTimeStamp = data.getTime()
    var minute = 1000 * 60;      //把分，时，天，周，半个月，一个月用毫秒表示
    var hour = minute * 60;
    var day = hour * 24;
    var week = day * 7;
    var month = day * 30;
    var year = month * 12;
    var now = new Date().getTime();   //获取当前时间毫秒
    var diffValue = now - dateTimeStamp;//时间差

    var result = "";
    if (diffValue < 0) {
        result = "" + "未来";
    }
    var minC = diffValue / minute;  //计算时间差的分，时，天，周，月
    var hourC = diffValue / hour;
    var dayC = diffValue / day;
    var weekC = diffValue / week;
    var monthC = diffValue / month;
    var yearC = diffValue / year;

    if (yearC >= 1) {
        result = " " + parseInt(yearC) + "年前"
    } else if (monthC >= 1 && monthC < 12) {
        result = " " + parseInt(monthC) + "月前"
    } else if (weekC >= 1 && weekC < 5 && dayC > 6 && monthC < 1) {
        result = " " + parseInt(weekC) + "周前"
    } else if (dayC >= 1 && dayC <= 6) {
        result = " " + parseInt(dayC) + "天前"
    } else if (hourC >= 1 && hourC <= 23) {
        result = " " + parseInt(hourC) + "小时前"
    } else if (minC >= 1 && minC <= 59) {
        result = " " + parseInt(minC) + "分钟前"
    } else if (diffValue >= 0 && diffValue <= minute) {
        result = "刚刚"
    }
    console.log(result)
    return result
}
// 时间格式化
export function formateTime(datetime) {
    if (datetime == null) return ''

    datetime = datetime.replace(/-/g, '/')

    let time = new Date()
    let outTime = new Date(datetime)
    if (/^[1-9]\d*$/.test(datetime)) {
        outTime = new Date(parseInt(datetime) * 1000)
    }

    if (
        time.getTime() < outTime.getTime() ||
        time.getFullYear() != outTime.getFullYear()
    ) {
        return parseTime(outTime, '{y}-{m}-{d} {h}:{i}')
    }

    if (time.getMonth() != outTime.getMonth()) {
        return parseTime(outTime, '{m}-{d} {h}:{i}')
    }

    if (time.getDate() != outTime.getDate()) {
        let day = outTime.getDate() - time.getDate()
        if (day == -1) {
            return parseTime(outTime, '昨天 {h}:{i}')
        }

        if (day == -2) {
            return parseTime(outTime, '前天 {h}:{i}')
        }

        return parseTime(outTime, '{m}-{d} {h}:{i}')
    }

    let diff = time.getTime() - outTime.getTime()

    if (time.getHours() != outTime.getHours() || diff > 30 * 60 * 1000) {
        return parseTime(outTime, '{h}:{i}')
    }

    let minutes = outTime.getMinutes() - time.getMinutes()
    if (minutes == 0) {
        return '刚刚'
    }

    minutes = Math.abs(minutes)
    return `${minutes}分钟前`
}
// 转换时间
export function parseTime(time, cFormat) {
    if (arguments.length === 0) {
        return null
    }

    let date
    const format = cFormat || '{y}-{m}-{d} {h}:{i}:{s}'

    if (typeof time === 'object') {
        date = time
    } else {
        if (typeof time === 'string' && /^[0-9]+$/.test(time)) {
            time = parseInt(time)
        }
        if (typeof time === 'number' && time.toString().length === 10) {
            time = time * 1000
        }

        date = new Date(time.replace(/-/g, '/'))
    }

    const formatObj = {
        y: date.getFullYear(),
        m: date.getMonth() + 1,
        d: date.getDate(),
        h: date.getHours(),
        i: date.getMinutes(),
        s: date.getSeconds(),
        a: date.getDay(),
    }

    const time_str = format.replace(/{([ymdhisa])+}/g, (result, key) => {
        const value = formatObj[key]
        // Note: getDay() returns 0 on Sunday
        if (key === 'a') {
            return ['日', '一', '二', '三', '四', '五', '六'][value]
        }

        return value.toString().padStart(2, '0')
    })

    return time_str
}
export function copyDomText(val) {
    // 获取需要复制的元素以及元素内的文本内容
    const text = val;
    // 添加一个input元素放置需要的文本内容
    const input = document.createElement("input");
    input.value = text;
    document.body.appendChild(input);
    // 选中并复制文本到剪切板
    input.select();
    document.execCommand("copy");
    // 移除input元素
    document.body.removeChild(input);
    ElMessage({
        message: "Copy Success",
        type: "success",
        duration: 1000
    });
}
// 随机生成4位数
export function randomFour() {
    var code = '';
    //设置长度，这里看需求，我这里设置了4
    var codeLength = 4;

    //设置随机字符
    var random = new Array(0, 1, 2, 3, 4, 5, 6, 7, 8, 9);

    //循环codeLength 我设置的4就是循环4次
    for (var i = 0; i < codeLength; i++) {
        //设置随机数范围,这设置为0 ~ 36
        var index = Math.floor(Math.random() * 9);

        //字符串拼接 将每次随机的字符 进行拼接
        code += random[index];
    }
    //将拼接好的字符串赋值给展示的code
    return code;
}
// 银行卡四位换成*
export function cardNumberReplace(value) {
    console.log(value);
    return value;
}